import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Ruler(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M22.707 14.707l-4 4-1.414-1.414 4-4-1.586-1.586-2 2-1.414-1.414 2-2-1.586-1.586-4 4-1.414-1.414 4-4-1.586-1.586-2 2-1.414-1.414 2-2-1.586-1.586-4 4-1.414-1.414 4-4-.707-.707a2 2 0 00-2.83 0L.587 5.757a2 2 0 000 2.83l14.828 14.827a2 2 0 002.829 0l5.17-5.17a2 2 0 000-2.83l-.706-.707z"
  }));
}

export { Ruler };
//# sourceMappingURL=Ruler.js.map